module.exports = __webpack_public_path__ + "img/ep-rectangle-gonfle.4a92193b.jpg";